import React, { useState, useEffect } from 'react'
import {
  Segment,
  Loader,
  Divider,
  Grid,
  Header,
  Button,
} from 'semantic-ui-react'
import './MxPressReleases.css'
import env from '../../../env'
import useAxios from '../../../lib/auth/useAxios'
import MickeyPlaceholder from '../../../components/Placeholder/Placeholder'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const MxPressReleases = () => {
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const axios = useAxios()
  const navigate = useNavigate()
  const [pressReleases, setPressReleases] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (
      env.REACT_APP_REDIRECT &&
      env.REACT_APP_REDIRECT !== 'false' &&
      env.REACT_APP_REDIRECT !== 'null'
    ) {
      navigate('/login')
    }
  }, [])

  useEffect(() => {
    setLoading(true)
    const getPress = async () => {
      let res = await axios.get('/main/press-releases/', {
        params: {
          today: new Date(),
        },
      })
      if (res?.data?.results) {
        setPressReleases(res?.data?.results)
        setLoading(false)
      }
    }
    getPress()
  }, [])

  return (
    <Grid id="press-page">
      <Grid.Column width={window.width < 768 ? 15 : 14}>
        <Header className="main-heading" as={'h1'} style={{ fontSize: '36px' }}>
          Press{' '}
        </Header>
        <Divider />
        {pressReleases &&
          !loading &&
          pressReleases?.length > 0 &&
          pressReleases?.map((pressRelease) => {
            return (
              <>
                <Grid stackable className="press-row" width={16}>
                  <Grid.Column className="info-wrapper" width={13}>
                    <h5 className="heading">{pressRelease.publish_date}</h5>
                    <h3 className="sec-heading">{pressRelease.title}</h3>
                    <p
                      className="para-heading"
                      dangerouslySetInnerHTML={{
                        __html:
                          pressRelease?.content?.length > 375
                            ? pressRelease?.content.slice(0, 375)
                            : pressRelease?.content,
                      }}
                    />
                    {pressRelease.content &&
                      pressRelease.content.length > 375 && (
                        <a
                          className="read-more"
                          href={`/press/${pressRelease.press_link}`}
                        >
                          ... Read More
                        </a>
                      )}
                  </Grid.Column>
                  <Grid.Column className="button-wrapper" width={3}>
                    <Button
                      style={{
                        '--primaryColor': tenant?.deployment_primary_color,
                        '--secondaryButtonColor':
                          env.REACT_APP_SECONDARY_BUTTON_COLOR,
                        padding: '1rem',
                        borderRadius: '500px',
                      }}
                      color="primary"
                      onClick={() =>
                        navigate(`/press/${pressRelease.press_link}`)
                      }
                    >
                      View Full Press Release
                    </Button>
                  </Grid.Column>
                </Grid>
                <Divider />
              </>
            )
          })}

        {!loading && pressReleases && pressReleases.length < 1 && (
          <MickeyPlaceholder
            icon={'wordpress forms'}
            message={'No Press Releases'}
            style={{
              backgroundColor: 'white',
              border: 'none',
              boxShadow: 'none',
            }}
          />
        )}
        {loading && pressReleases && pressReleases.length < 1 && (
          <Segment style={{ width: '100%', height: '200px' }}>
            <Loader active />
          </Segment>
        )}
      </Grid.Column>
    </Grid>
  )
}

export default MxPressReleases
